import { defineComponent, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useAvailableWhitelabelsConfigStore } from '@/store/multibrand/available-whitelabels-config-list.store';
import { iconPageMultibrand } from '@/models/constants';
import { usePspTagListStore } from '@/store/psp-tag/psp-tag-list.store';

export default defineComponent({
  name: 'PspTagsPage',
  setup() {
    const pspTagStore = usePspTagListStore();
    const { getPspTagList } = pspTagStore;
    const { pspTagList } = storeToRefs(pspTagStore);

    const { isOnlyOneWhitelabelAvailable } = storeToRefs(useAvailableWhitelabelsConfigStore());

    onMounted(() => {
      getPspTagList();
    });

    return {
      isOnlyOneWhitelabelAvailable,
      iconPageMultibrand,
      pspTagList,
    };
  },
});
